"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityManager = void 0;
var signal_1 = require("@yoieh/signal");
var __1 = require("..");
var EntityManager = /** @class */ (function () {
    function EntityManager() {
        this.onEntityAdded = new signal_1.Signal();
        this.onEntityRemoved = new signal_1.Signal();
        this._entities = [];
        this.entityId = 0;
    }
    Object.defineProperty(EntityManager, "instance", {
        get: function () {
            if (!EntityManager._instance) {
                EntityManager._instance = new EntityManager();
            }
            return EntityManager._instance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EntityManager.prototype, "entities", {
        get: function () {
            return this._entities;
        },
        enumerable: false,
        configurable: true
    });
    EntityManager.prototype.getEntity = function (id) {
        return this.entities.find(function (entity) { return entity.id === id; });
    };
    EntityManager.prototype.getEntities = function () {
        return this.entities;
    };
    EntityManager.prototype.addEntity = function (entity) {
        this.entities.push(entity);
        this.onEntityAdded.dispatch(entity);
        return entity;
    };
    EntityManager.prototype.removeEntity = function (id) {
        var entity = this.getEntity(id);
        if (entity) {
            //   entity.remove();
            this._entities = this.entities.filter(function (e) { return e.id !== id; });
            this.onEntityRemoved.dispatch(entity);
        }
    };
    EntityManager.prototype.createEntity = function () {
        this.entityId += 1;
        var entity = new __1.Entity(this.entityId);
        this.addEntity(entity);
        return entity;
    };
    return EntityManager;
}());
exports.EntityManager = EntityManager;
